import Node from "./Node";
import {escapeHtmlSymbols} from "../../../atUtils"

export default class EntityNode extends Node {
    constructor({
        tokensHighlighter,
        onClick = () => {}
    }) {
        super(onClick)

        this.tokensHighlighter = tokensHighlighter

        this.state = {
            ...this.state,
            editing: false,
            editable: false
        }

        this.onStatePropertyChanged('editing', (editing) => this.$el.toggleClass("editing", editing))
        this.onStatePropertyChanged('editable', (editable) => this.$el.toggleClass("editable", editable))
    }

    templateModel() {
        return {title: this.tokensHighlighter ? this.tokensHighlighter.highlightTokens(this.title()) : escapeHtmlSymbols(this.title())}
    }

    title() {
        // Abstract
    }

    /**
     * @return {Tooltip}
     */
    editTooltip() {
        // Abstract
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/EntityNode.js